<template>
  <div
    class="card"
    :class="{ 'card-disabled': card.disabled }"
    @click="goToModule"
  >
    <div class="d-flex flex-column align-center justify-center">
      <img :src="card.icon" alt="ach icon" />
      <p class="text-center">{{ card.title }}</p>
    </div>
  </div>
</template>
<script>
export default {
  name: "cardComp",
  props: {
    card: {
      type: Object,
      required: true,
    },
  },
  methods: {
    goToModule() {
      if (this.card.disabled) return;
      this.$router.push(this.card.link);
    },
  },
};
</script>
<style scoped>
.card {
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  max-width: 10vw;
  box-shadow: 0px 2px 20px 0px rgba(30, 41, 59, 0.12);
  background-color: #fff;
  border-radius: 24px;
  padding: 0.75vw 1.5vw;
  margin: 0 auto;
  transition: all 0.9s ease;
}
.card-disabled {
  cursor: not-allowed !important;
  opacity: 0.6;
  filter: grayscale(1);
}
.card-disabled:hover {
  background: #fff !important;
  box-shadow: 0px 2px 20px 0px rgba(30, 41, 59, 0.12) !important;
}
.card-disabled:hover img {
  filter: none !important;
}
.card-disabled:hover p {
  color: #000 !important;
}
.card:not(.card-disabled):hover {
  cursor: pointer;
  background: linear-gradient(
    135.94deg,
    #00363f 17.54%,
    #015764 54.21%,
    #007586 81.65%,
    #0293a9 115.97%
  );
  box-shadow: 0px 2px 20px 0px rgba(30, 41, 59, 0.92);
  transition: all 0.9s ease;
}
.card:not(.card-disabled):hover a {
  color: rgba(248, 250, 252, 1);
}
.card img {
  display: block;
  margin-bottom: 0.6vw;
  width: 3.2vw;
  height: auto;
}
.card:not(.card-disabled):hover img {
  filter: brightness(0) invert(1);
}
.card:not(.card-disabled):hover p {
  color: #fff;
}
.card p {
  font-size: 0.85vw;
  white-space: nowrap;
}
.card a {
  text-decoration: none;
  color: #00363f;
  font-weight: 500;
  font-size: 14px;
}
</style>
